import {required} from "../utils/Validator";
import Joi from "joi";

export const createInitialLage = () => {
    return {
        hochwert: null,
        rechtswert: null,
    };
};

export const createLageSchema = () => {
    return {
        rechtswert: lageValidation(),
        hochwert: lageValidation(),
    };
};

const lageValidation = () => {
    return required(Joi.number().max(99999999.99).message("Der eingegebene Wert ist zu groß.").precision(2));
}
